import { ButtonHTMLAttributes, ReactElement } from "react";

import styles from "./CountButton.module.css";

/**
 * The properties for a {@link CountButton} component.
 */
interface CountButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    /**
     * The count shown on the button.
     */
    count: number;

    /**
     * CSS classes to apply on the inline text element within the button.
     */
    textClassName?: string;

    /**
     * Size of the button
     */
    size?: "md" | "sm"
}

/**
 * A button that shows a number in square brackets and mimics the display style of an anchor.
 * @param props The component properties.
 *
 * @example
 * <CountButton onClick={() => alert('Button clicked!')} count={10} />
 */
function CountButton(props: Readonly<CountButtonProps>): ReactElement {
    const buttonCountLabel = props.count > 0 ? props.count : "+";

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { textClassName, ...buttonProps } = props;

    return (
        <button
            {...buttonProps}
            className={`${styles["count-button"]} ${props.className ?? ""}`}
        >
            [{props.size !== "sm" && " "}<span className={props.textClassName}>{buttonCountLabel}</span>{props.size !== "sm" && " "}]
        </button>
    );
}

export { CountButton };
